(function ($) {
    $(".plyr-player").length > 0 &&  require("./custom/video-payer.es6");
    $(".hero").length > 0 && require("./page_builder/hero.es6");
})(jQuery);